module.exports = __webpack_public_path__ + "static/img/irole.65acaad.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/kc/irole.png
// module id = lnbE
// module chunks = 7